import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useOnScroll } from 'vue-composable';
import GenericPage from '@/views/GenericPage/GenericPage.vue';
import Privacy from '@/views/Privacy/Privacy.vue';
import ISO from '@/views/ISO/ISO.vue';
import PageNotFound from '@/views/PageNotFound/PageNotFound.vue';
import { smoothScroll } from '@/utils/smoothScroll';

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'home',
		component: GenericPage,
	},
	{
		path: '/over-ons',
		name: 'over-ons',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen',
		name: 'onze-opleidingen',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen/allround-horeca-medewerker',
		name: 'onze-opleidingen-allround-horeca-medewerker',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen/basiskok',
		name: 'onze-opleidingen-basiskok',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen/bedieningsassistent',
		name: 'onze-opleidingen-bedieningsassistent',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen/gastheer-gastvrouw',
		name: 'onze-opleidingen-gastheer-gastvrouw',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen/keukenassistent',
		name: 'onze-opleidingen-keukenassistent',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen/turbo-keukenassistent',
		name: 'onze-opleidingen-turbo-keukenassistent',
		component: GenericPage,
	},
	{
		path: '/onze-opleidingen/zelfstandig-werkend-kok',
		name: 'onze-opleidingen-zelfstandig-werkend-kok',
		component: GenericPage,
	},
	{
		path: '/zakelijk',
		name: 'zakelijk',
		component: GenericPage,
	},
	{
		path: '/contact',
		name: 'contact',
		component: GenericPage,
	},
	{
		path: '/privacy',
		name: 'privacy',
		component: Privacy,
	},
	{
		path: '/KRMBV-ISO9001',
		name: 'ISO',
		component: ISO,
	},
	{
		path: '/:pathMatch(.*)*',
		name: '404',
		component: PageNotFound,
	},
];

const { scrollTop } = useOnScroll();

interface Route {
	name: string;
	hash: string;
}

const scrollBehavior = (to: Route, from: Route) => {
	if (to.hash) {
		return new Promise((resolve) => {
			const delay = to.name === from.name ? 1 : 500;
			setTimeout(() => {
				const topOffset = scrollTop.value === 0 ? 182 : 90;
				const el: HTMLElement | null = document.getElementById(to.hash.substring(1));
				if (el) {
					smoothScroll((el.offsetTop - topOffset), 1500);
				} else {
					smoothScroll(0, 1500);
				}

				resolve({});
			}, delay);
		});
	}

	if (to.name === from.name) {
		smoothScroll(0, 1500);
		return {};
	}

	return { left: 0, top: 0 };
};

const router = createRouter({
	history: createWebHistory(),
	// eslint-disable-next-line
	// @ts-ignore
	scrollBehavior,
	routes,
});

export default router;
